import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { grey, red } from '@mui/material/colors';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 400, bgcolor: 'white', borderRadius: 4, p: 4, outline: 'none', textAlign: 'center'
};

export default function DeletePop({ rol, refresh }) {
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    try {
      const res = await fetch(`${BASE_URL}/roles/${rol.id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        setOpen(false);
        refresh(); // Esto recarga la tabla en RolesPage
      }
    } catch (e) {
      console.error("Error al eliminar:", e);
    }
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}
      sx={{'&:hover': {color:grey[100], bgcolor: red[400] } }}>
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" textAlign={'left'} mb={1}>{`¿Eliminar el rol ${rol.nombre}?`}</Typography>
          <Typography variant="body1" color='textSecondary' mb={2} textAlign={'left'}>
            ¿Estás seguro que deseas eliminar este rol permanentemente?.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 ,justifyContent:'right'}}>
            <Button fullWidth variant="contained" 
                    sx={{ color: 'black', bgcolor:grey[100], textTransform: 'none',width: { xs: '50%', sm: '35%' } }} 
                    onClick={() => setOpen(false)}>
              No, cancelar
            </Button>
            <Button fullWidth variant="contained" 
                    sx={{ bgcolor: red[400], '&:hover': { bgcolor: red[600] }, textTransform: 'none',width: { xs: '50%', sm: '35%' } }} 
                    onClick={handleDelete}>
              Sí, eliminar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}